'use strict';
import {
  UPDATE_DOMAIN_MODAL,
  UPDATE_DOMAIN_MODAL_LOADING_STATUS,
} from '../actions/domainModal';

const defVal = {
  modalItme: null,
  oprType: null,
  visible: false,
  loading: false,
  opType: 'ADD'
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_DOMAIN_MODAL:
      return Object.assign({}, state, {
        modalItme:action.modalItme,
        visible: action.visible,
        opType: action.opType
      });

    case UPDATE_DOMAIN_MODAL_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading
      });

    default:
      return state;
  }
};
